var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebris = function SvgDebris(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 11.208.951-.951h1.306V8.95l.95-.95-.95-.952V5.743H8.95L8 4.793l-.951.95H5.743V7.05L4.793 8l.95.951v1.306H7.05zm0 3.864L5.906 13H3v-2.906L.928 8 3 5.906V3h2.906L8 .928 10.094 3H13v2.906L15.072 8 13 10.094V13h-2.906zm0-1.405L9.667 12H12V9.667L13.667 8 12 6.333V4H9.667L8 2.333 6.333 4H4v2.333L2.333 8 4 9.667V12h2.333z"
  })));
};
export default SvgDebris;